import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import type { InstoreInformation} from '@app/_services/instoredetails'; 
import type { HoardingInformation,HoardingLists } from '@app/_services/hoarding'; 
import type { Instore, InstoreLists, BulkInstoreValResponse, BulkInstoreUploadResponse, BulkHoardingValResponse, CampaignInformation } from '@app/_services/Instore'; 
import type { CampaignLists } from '@app/_services/Instore'; 
import type { FloorLists, LocationLists } from '@app/_services/account.service';
import type { InstoreExpiry,InstoreUnChangedAds } from '@app/_services/InstoreExpiry'; 
import type { HoardingExpiry,HoardingsUnchangedAds } from '@app/_services/HoardingExpiry'; 

@Injectable({ providedIn: 'root' })
export class InstoreService {
    private REST_API_SERVER = "https://brandmonitoringapp.grtjewels.com";
    // private REST_API_SERVER = "http://172.16.200.74:3001";
    // private REST_API_SERVER = "http://localhost:3000";
    constructor(
        private router: Router,
        private http: HttpClient
    ) {

    }

    getFloorLists(showroom: any) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("showroom_id", showroom)
        return this.http.get<FloorLists>(this.REST_API_SERVER +'/api/floor/', {headers: headers, params: params});
    }

    getLocationLists(showroom: any, floor: any) {    
        //console.log("getLocationLists "+showroom + " "+ floor);
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("showroom_id",showroom).set("floor_id", floor);
        return this.http.get<LocationLists>(this.REST_API_SERVER +'/api/location/', {headers: headers, params: params});
    }
    restoreInstore(instoreID:any){
        let authToken = localStorage.getItem('authtoken');   
        const options = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              
              'Authorization': 'Bearer '+authToken
            }),
            body: {
                "instore_id" : instoreID,
                "is_discontinued":0
            }
          }
      
          return this.http.delete<any>(this.REST_API_SERVER +'/api/instore/discontinue', options);
    }

    restoreHoarding(hoardingID:any){
        let authToken = localStorage.getItem('authtoken');   
        const options = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              
              'Authorization': 'Bearer '+authToken
            }),
            body: {
                "hoarding_id" : hoardingID,
                "is_discontinued":0
            }
          }
      
          return this.http.delete<any>(this.REST_API_SERVER +'/api/hoarding/discontinue', options);
    }
    getInstoreLists(showroom_id) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        // let params = new HttpParams().set("is_discontinued", "0");
        let params = new HttpParams().set("showroom_id",showroom_id);
        return this.http.get<InstoreLists>(this.REST_API_SERVER +'/api/instore/', {headers: headers, params: params});
    }
    
    getShowroomInstoreLists(showroomID:any) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("showroom_id",showroomID).set("is_discontinued", "0");
        return this.http.get<InstoreLists>(this.REST_API_SERVER +'/api/instore/', {headers: headers, params: params});
    }
    getAllCampaignLists() {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams(); //.set("showroom_id",showroom).set("floor_id", floor);
        return this.http.get<CampaignLists>(this.REST_API_SERVER +'/api/campaign/', {headers: headers, params: params});
    }

    getHoardingLists(showroom_id) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("showroom_id",showroom_id); //.set("is_discontinued", "0");
        return this.http.get<HoardingLists>(this.REST_API_SERVER +'/api/hoarding/', {headers: headers, params: params});
    }

    getShowroomHoardingLists(showroomID:any) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("showroom_id",showroomID).set("is_discontinued", "0");
        return this.http.get<HoardingLists>(this.REST_API_SERVER +'/api/hoarding/', {headers: headers, params: params});
    }


    instoreSingleModify(formdata: FormData) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Authorization': 'Bearer '+authToken })
        let params = new HttpParams(); 
        return this.http.post<any>(this.REST_API_SERVER +`/api/instore/modify`, formdata, { 
            headers: headers 
        });
    }
    instoreSingleUpdate(formdata: FormData) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Authorization': 'Bearer '+authToken })
        let params = new HttpParams(); 
        return this.http.post<any>(this.REST_API_SERVER +`/api/instore/update`, formdata, { 
            headers: headers 
        });
    }

    instoreBulkModify(formdata: FormData) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({ 'Authorization': 'Bearer '+authToken })
        return this.http.post<any>(this.REST_API_SERVER +`/api/instore/bulkmodify`, formdata, { 
            headers: headers 
        });
    }
    instoreBulkUpdate(formdata: FormData) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Authorization': 'Bearer '+authToken })
        return this.http.post<any>(this.REST_API_SERVER +`/api/instore/bulkupdate`, formdata, { 
            headers: headers 
        });
    }

    instoreDiscontinue(instoreID: any,is_discontinued:any) {   
        let authToken = localStorage.getItem('authtoken');   
        const options = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              
              'Authorization': 'Bearer '+authToken
            }),
            body: {
                
                "instore_id" : instoreID,
                "is_discontinued":is_discontinued
            }
          }
      
          return this.http.delete<any>(this.REST_API_SERVER +'/api/instore/discontinue', options);
    }

    instoreRequestEmail(userID:any,instoreID: any,mailRequest:any) {   
        
          let authToken = localStorage.getItem('authtoken');   
          const headers = new HttpHeaders({ 'Authorization': 'Bearer '+authToken })
          return this.http.post<any>(this.REST_API_SERVER +`/api/instore/sendrequest`, {"user_id": localStorage.getItem('userId'),"instore_id": instoreID,"mailRequest":mailRequest}, { headers: headers });
    }

    bulkinstoreDiscontinue(instoreID: any,is_discontinued:any) { 
        let authToken = localStorage.getItem('authtoken');   
        const options = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              
              'Authorization': 'Bearer '+authToken
            }),
            body: {
                "instore_ids" : instoreID,
                "is_discontinued":is_discontinued
            }
          }
          return this.http.delete<any>(this.REST_API_SERVER +'/api/instore/bulkdiscontinue', options);
    }


    hoardingDiscontinue(hoarding_id: any,is_discontinued:any) {    

        let authToken = localStorage.getItem('authtoken');   
        const options = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              
              'Authorization': 'Bearer '+authToken
            }),
            body: {
                "hoarding_id" : hoarding_id,
                "is_discontinued":is_discontinued
            }
          }
          return this.http.delete<any>(this.REST_API_SERVER +'/api/hoarding/discontinue', options);

    }
    hoardingsrequestEmail(userID:any,hoarding_id: any,mailRequest:any) {   
        // let authToken = localStorage.getItem('authtoken');   
        // const options = {
        //     headers: new HttpHeaders({
        //       'Content-Type': 'application/json',
        //       'Authorization': 'Bearer '+authToken
        //     }),
        //     body: {
        //         "user_id":userID,
        //         "hoarding_id" : hoarding_id,
        //         "mailRequest":mailRequest
        //     }
        //   }
        //   return this.http.post<any>(this.REST_API_SERVER +'/api/hoarding/sendrequest', options);

          let authToken = localStorage.getItem('authtoken');   
          const headers = new HttpHeaders({ 'Authorization': 'Bearer '+authToken })
          return this.http.post<any>(this.REST_API_SERVER +`/api/instore/sendrequest`, {"user_id": userID,"hoarding_id": hoarding_id,"mailRequest":mailRequest}, { headers: headers });

    }


    bulkhoardingDiscontinue(hoarding_ids: any,is_discontinued:any) { 
        let authToken = localStorage.getItem('authtoken');   
        const options = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              
              'Authorization': 'Bearer '+authToken
            }),
            body: {
                "hoarding_ids" : hoarding_ids,
                "is_discontinued":is_discontinued
            }
          }
          return this.http.delete<any>(this.REST_API_SERVER +'/api/hoarding/bulkdiscontinue', options);
    }
    hoardingSingleModify(formdata: FormData) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Authorization': 'Bearer '+authToken })
        let params = new HttpParams(); 
        return this.http.post<any>(this.REST_API_SERVER +`/api/hoarding/modify`, formdata, { 
            headers: headers 
        });
    }
    hoardingSingleUpdate(formdata: FormData) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Authorization': 'Bearer '+authToken })
        let params = new HttpParams(); 
        return this.http.post<any>(this.REST_API_SERVER +`/api/hoarding/update`, formdata, { 
            headers: headers 
        });
    }
    hoardingBulkModify(formdata: FormData) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({ 'Authorization': 'Bearer '+authToken })
        return this.http.post<any>(this.REST_API_SERVER +`/api/hoarding/bulkmodify`, formdata, { 
            headers: headers 
        });
    }
    hoardingBulkUpdate(formdata: FormData) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Authorization': 'Bearer '+authToken })
        return this.http.post<any>(this.REST_API_SERVER +`/api/hoarding/bulkupdate`, formdata, { 
            headers: headers 
        });
    }
    getHoardingInformation(hoardingID:any) {  
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("hoarding_id",hoardingID);
        return this.http.get<HoardingInformation>(this.REST_API_SERVER +'/api/hoarding/details', {headers: headers, params: params});
    } 
    
    getInstoreInformation(instoreID:any) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("instore_id",instoreID);
        return this.http.get<InstoreInformation>(this.REST_API_SERVER +'/api/instore/details', {headers: headers, params: params});
    }
    getCampaignLists(showroomID:any,festivalID:any) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("showroom_id",showroomID).set("campaign_id", festivalID);;
        return this.http.get<CampaignLists>(this.REST_API_SERVER +'/api/campaign', {headers: headers, params: params});
    }
    
    compare(a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    isUpdateOrModify:boolean;
    selected_region_id;
    selected_showroom_id;
    instoreData:any=[];
    hoardingData:any=[];
    
    
    setIsUpdateorModify(val: boolean) {
      this.isUpdateOrModify=val;
    }
    getIsUpdateorModify() {
        return this.isUpdateOrModify;
    }

    setRegionID(RegionID){
        this.selected_region_id = RegionID;
    }
    getRegionID() {
        return this.selected_region_id;
    }

    setShowRoomID(showRoomID){
        this.selected_showroom_id = showRoomID;
    }
    getShowroomID() {
        return this.selected_showroom_id;
    }

    setInstoreData(data) {
        this.instoreData= data;
    }
    getInstoreData() {
        return this.instoreData;
    }
    clearInstoreData() {
        this.instoreData = [];
        return this.instoreData;
    }
    setHoardingData(data) {
        this.hoardingData= data;
    }
    getHoardingData() {
        return this.hoardingData;
    }
    clearHoardingData() {
        this.hoardingData = [];
        return this.hoardingData;
    }
    
     /* ---------Vinay  -------------- */
     validateBulkInstore(bodydata: any) {
        let authToken = localStorage.getItem('authtoken');   
        //console.log("getUserLists token "+authToken);
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
            //'Content-Type': 'undefined',
            'Authorization': 'Bearer '+authToken
        })
     
        //console.log("validateBulkInstore "+bodydata);

        return this.http.post<BulkInstoreValResponse>(this.REST_API_SERVER +`/api/instore/bulkvalidate`, bodydata, { 
            //transformRequest: angular.identity,
            headers: headers 
        });                                                    
    }

    uploadBulkInstore(bodydata: any) {
        let authToken = localStorage.getItem('authtoken');   
        //console.log("getUserLists token "+authToken);
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
            //'Content-Type': 'undefined',
            'Authorization': 'Bearer '+authToken
        })
     
        //console.log("validateBulkInstore "+bodydata);

        return this.http.post<BulkInstoreUploadResponse>(this.REST_API_SERVER +`/api/instore/bulkimport`, bodydata, { 
            //transformRequest: angular.identity,
            headers: headers 
        });                                                    
    }

    validateBulkHoarding(bodydata: any) {
        let authToken = localStorage.getItem('authtoken');   
        //console.log("getUserLists token "+authToken);
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
            //'Content-Type': 'undefined',
            'Authorization': 'Bearer '+authToken
        })
     
        //console.log("validateBulkHoarding "+bodydata);

        return this.http.post<BulkHoardingValResponse>(this.REST_API_SERVER +`/api/hoarding/bulkvalidate`, bodydata, { 
            //transformRequest: angular.identity,
            headers: headers 
        });                                                    
    }

    uploadBulkHoarding(bodydata: any) {
        let authToken = localStorage.getItem('authtoken');   
        //console.log("getUserLists token "+authToken);
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
            //'Content-Type': 'undefined',
            'Authorization': 'Bearer '+authToken
        })
     
        //console.log("uploadBulkHoarding "+bodydata);

        return this.http.post<BulkInstoreUploadResponse>(this.REST_API_SERVER +`/api/hoarding/bulkimport`, bodydata, { 
            //transformRequest: angular.identity,
            headers: headers 
        });                                                    
    }
    
    addInstore(formdata: FormData) {
        let authToken = localStorage.getItem('authtoken');   
        //console.log("getUserLists token "+authToken);
        const headers = new HttpHeaders({
            //'Content-Type':  'multipart/form-data',
            //'Content-Type': 'undefined',
            
            'Authorization': 'Bearer '+authToken
        })
     
        //console.log(formdata);

        return this.http.post<any>(this.REST_API_SERVER +`/api/instore/add`, formdata, { 
            //transformRequest: angular.identity,
            headers: headers 
        });

    }

    addCampaign(formdata: FormData) {
        let authToken = localStorage.getItem('authtoken');   
        //console.log("getUserLists token "+authToken);
        const headers = new HttpHeaders({
            //'Content-Type':  'multipart/form-data',
            //'Content-Type': 'undefined',
            
            'Authorization': 'Bearer '+authToken
        })
     
        //console.log(formdata);

        return this.http.post<any>(this.REST_API_SERVER +`/api/campaign/add`, formdata, { 
            //transformRequest: angular.identity,
            headers: headers 
        });

    }

    addHoarding(formdata: FormData) {
        let authToken = localStorage.getItem('authtoken');   
        //console.log("getUserLists token "+authToken);
        const headers = new HttpHeaders({
            //'Content-Type': 'application/json',
            
            'Authorization': 'Bearer '+authToken
        })

        return this.http.post<any>(this.REST_API_SERVER +`/api/hoarding/add`, formdata, { headers: headers });
    }  
    
    getInstoreExpiryAdds(region_id, showroom_id) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("region_id",region_id).set("showroom_id",showroom_id).set("expiry_days","1,0,10").set("is_discontinued","0");
        return this.http.get<InstoreExpiry>(this.REST_API_SERVER +'/api/instore/expiryadds', {headers: headers, params: params});
    } 

    getInstoreUnchangedAds(region_id, showroom_id) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("region_id",region_id).set("showroom_id",showroom_id).set("unchanged_days","10,30,180,720,1825");
        //console.log(this.REST_API_SERVER +'/api/instore/unchangedadds', {headers: headers, params: params})
        return this.http.get<InstoreUnChangedAds>(this.REST_API_SERVER +'/api/instore/unchangedadds', {headers: headers, params: params});
    }

    getHoardingExpiryAdds(region_id, showroom_id) {    
        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("region_id",region_id).set("showroom_id",showroom_id).set("expiry_days","1,0,10").set("is_discontinued","0");
        return this.http.get<HoardingExpiry>(this.REST_API_SERVER +'/api/hoarding/expiryadds', {headers: headers, params: params});
    } 

    getHoardingUnchangedAds(region_id, showroom_id) {   

        let authToken = localStorage.getItem('authtoken');   
        const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authToken })
        let params = new HttpParams().set("region_id",region_id).set("showroom_id",showroom_id).set("unchanged_days","10,30,180,720,1825");
        //console.log(this.REST_API_SERVER +'/api/hoarding/unchangedadds', {headers: headers, params: params})
        return this.http.get<HoardingsUnchangedAds>(this.REST_API_SERVER +'/api/instore/unchangedadds', {headers: headers, params: params});


    }

     /* ---------Vinay  -------------- */

}